
import URI from 'urijs';
import isArray from 'lodash/isArray';

import ErrorHttp from '../utils/ErrorHttp';

import loadJsonFromText from '../utils/loadJsonFromText';

function getDefaultRequestOptions(options) {
    let contentType = options.contentType || 'application/json';

    let reqOptions = {
        mode: 'cors',
        headers: {
            'Content-Type': contentType
        }
    };

    if (options.token) {
        reqOptions.headers = {
            ...reqOptions.headers,
            'Authorization': (options.token) ? `Token ${options.token}` : ''
        }
    }

    if (options.reqOptions) {
        reqOptions = {
            ...reqOptions,
            ...options.reqOptions
        };
    }

    return reqOptions;
}

export function callGet(options) {
    let url = getFunctionUrl(options);
    let callback = options.callback || (() => {});

    let reqOptions = {
        ...getDefaultRequestOptions(options),
        method: 'GET'
    };

    doFetch(url, reqOptions, callback);
}

export function callPost(options) {
    let url = getFunctionUrl(options);
    let callback = options.callback || (() => {});

    let reqOptions = {
        ...getDefaultRequestOptions(options),
        method: 'POST',
        body: JSON.stringify(options.body),
    };

    doFetch(url, reqOptions, callback);
}

export function doFetch(url, reqOptions, callback) {
    fetch(url, reqOptions)
        .then(response => {
            if (response.ok) {
                return response.text();
            } else {
                return response.text()
                    .then(text => {
                        throw new ErrorHttp(
                            'Internal error in call server API',
                            response.status,
                            text
                        );
                    });
            }
        })
        .then(content => {
            loadJsonFromText(content, callback);
        })
        .catch(error => {
            console.error('fetch failed:', error, error.status, error.body);
            callback(error);
        });
}

export function getFunctionUrl(options) {
    let url = `${options.baseUrl}/${options.module}/${options.name}`;
    let uri = new URI(url);
    if (isArray(options.params)) {
        options.params.forEach(item => {
            uri.setSearch(item[0], item[1]);
        });
    }

    return uri.toString();
}
